"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSDK = exports.getAddress = exports.ethereumMethods = exports.ethereumEvents = void 0;
var _snetSdkWeb = _interopRequireDefault(require("snet-sdk-web"));
var _web = _interopRequireDefault(require("web3"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EXPECTED_ID_ETHEREUM_NETWORK = Number(process.env.REACT_APP_ETH_NETWORK);
const ethereumMethods = exports.ethereumMethods = {
  REQUEST_ACCOUNTS: "eth_requestAccounts",
  REQUEST_CHAIN_ID: "eth_chainId",
  REQUEST_SWITCH_CHAIN: "wallet_switchEthereumChain"
};
const ethereumEvents = exports.ethereumEvents = {
  CHAIN_CHANGED: "chainChanged"
};
const DEFAULT_GAS_LIMIT = undefined;
const DEFAULT_GAS_PRICE = undefined;
const initSDK = async () => {
  try {
    const config = {
      networkId: EXPECTED_ID_ETHEREUM_NETWORK,
      web3Provider: window?.ethereum,
      defaultGasLimit: DEFAULT_GAS_LIMIT,
      defaultGasPrice: DEFAULT_GAS_PRICE,
      rpcEndpoint: process.env.REACT_APP_WEB3_PROVIDER,
      tokenName: process.env.REACT_APP_TOKEN_NAME,
      standType: process.env.REACT_APP_STAND
    };
    const sdk = await new _snetSdkWeb.default(config);
    return sdk;
  } catch (err) {
    throw new Error(err);
  }
};
exports.initSDK = initSDK;
const getAddress = async sdk => {
  try {
    if (!sdk?.account) {
      throw new Error("SDK is undefined");
    }
    const address = await sdk.account.getAddress();
    const web3 = new _web.default();
    const addressChecksum = web3.utils.toChecksumAddress(address);
    return addressChecksum;
  } catch (err) {
    throw new Error(err);
  }
};
exports.getAddress = getAddress;